<template>
  <div>
    <template v-if="mode === 'DESIGN'">
      <el-input size="small" class="disabled-box-true" disabled placeholder="显示发起人的入职日期"/>
    </template>
    <template v-else>
      <el-input v-if="!readerMode || perm==='E'" size="small" clearable v-model="placeholder" :placeholder="placeholder" :disabled="perm==='R'" maxlength="50"  show-word-limit/>
      <div v-else class="form-item-text">{{_value}}</div>
      <!-- <el-input v-else size="small" clearable v-model="_value" :placeholder="placeholder"  maxlength="50" show-word-limit disabled/> -->
    </template>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "JoinDate",
  components: {},
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.disabled-box-true /deep/ .el-input__inner{
  background-color:#F5F7FA!important;
}
</style>
